
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 17.5H2a2 2 0 00-2 2V22a2 2 0 002 2h2.5a2 2 0 002-2v-2.5a2 2 0 00-2-2zm0 4.5H2v-2.5h2.5zM22 17.5h-2.5a2 2 0 00-2 2V22a2 2 0 002 2H22a2 2 0 002-2v-2.5a2 2 0 00-2-2zm0 4.5h-2.5v-2.5H22zM4.5 8.75H2a2 2 0 00-2 2v2.5a2 2 0 002 2h2.5a2 2 0 002-2v-2.5a2 2 0 00-2-2zm0 4.5H2v-2.5h2.5zM22 8.75h-2.5a2 2 0 00-2 2v2.5a2 2 0 002 2H22a2 2 0 002-2v-2.5a2 2 0 00-2-2zm0 4.5h-2.5v-2.5H22zM4.5 0H2a2 2 0 00-2 2v2.5a2 2 0 002 2h2.5a2 2 0 002-2V2a2 2 0 00-2-2zm0 4.5H2V2h2.5zm8.75 13h-2.5a2 2 0 00-2 2V22a2 2 0 002 2h2.5a2 2 0 002-2v-2.5a2 2 0 00-2-2zm0 4.5h-2.5v-2.5h2.5zm0-13.25h-2.5a2 2 0 00-2 2v2.5a2 2 0 002 2h2.5a2 2 0 002-2v-2.5a2 2 0 00-2-2zm0 4.5h-2.5v-2.5h2.5zm0-13.25h-2.5a2 2 0 00-2 2v2.5a2 2 0 002 2h2.5a2 2 0 002-2V2a2 2 0 00-2-2zm0 4.5h-2.5V2h2.5zM22 0h-2.5a2 2 0 00-2 2v2.5a2 2 0 002 2H22a2 2 0 002-2V2a2 2 0 00-2-2zm0 4.5h-2.5V2H22z"}})])
          )
        }
      }
    